import { Routes } from '@angular/router';
import { WorkOrderService } from '@app/admin/work-orders/shared/services/work-order.service';
import { activityGroupsRoutes } from '@app/admin/activity-groups/activity-groups.routes';
import { brandActivityMappingsRoutes } from '@app/admin/brand-activity-mapping/brand-activity-mappings.routes';
import { activitiesRoutes } from '@app/admin/activities/activities.routes';
import { usersRoutes } from '@app/admin/users/users.routes';
import { suppliersRoutes } from '@app/admin/suppliers/suppliers.routes';
import { disapprovalReasonsRoutes } from '@app/admin/disapproval-reasons/disapproval-reasons.routes';
import { rentalClassesRoutes } from '@app/admin/rental-classes/rental-classes.routes';
import { warrantiesRoutes } from '@app/admin/warranties/warranties.routes';
import { fleetOwnersRoutes } from '@app/admin/fleet-owners/fleet-owners.routes';
import { tyresRoutes } from '@app/admin/tyres/tyres.routes';

export const adminRoutes: Routes =
  [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'activities',
    },
    {
      path: 'brand-activity-mappings',
      children: brandActivityMappingsRoutes,
    },
    {
      path: 'activities',
      loadComponent: () => import('@app/admin/activities/activities.component').then(component => component.ActivitiesComponent),
      children: activitiesRoutes,
    },
    {
      path: 'users',
      children: usersRoutes,
    },
    {
      path: 'suppliers',
      children: suppliersRoutes,
    },
    {
      path: 'vehicles',
      children: [
        {
          path: '',
          loadComponent: () => import('@app/admin/search-vehicle/components/overview/overview.component'),
        },
      ],
    },
    {
      path: 'work-orders',
      providers: [WorkOrderService],
      children: [
        {
          path: '',
          loadComponent: () => import('@app/admin/work-orders/overview/overview.component').then(component => component.OverviewComponent),
        },
      ],
    },
    {
      path: 'activity-groups',
      children: activityGroupsRoutes,
    },
    {
      path: 'vehicle-types',
      children: [
        {
          path: '',
          loadComponent: () => import('@app/admin/vehicle-types/overview/overview.component').then(component => component.OverviewComponent),
        },
        {
          path: 'add',
          loadComponent: () => import('@app/admin/vehicle-types/add/add.component').then(component => component.AddComponent),
        },
        {
          path: ':vehicleTypeId',
          loadComponent: () => import('@app/admin/vehicle-types/details/details.component').then(component => component.DetailsComponent),
        },
        {
          path: ':vehicleTypeId/edit',
          loadComponent: () => import('@app/admin/vehicle-types/edit/edit.component').then(component => component.EditComponent),
        },
      ],
    },
    {
      path: 'disapproval-reasons',
      children: disapprovalReasonsRoutes,
    },
    {
      path: 'rental-classes',
      children: rentalClassesRoutes,
    },
    {
      path: 'warranties',
      children: warrantiesRoutes,
    },
    {
      path: 'fleet-owners',
      children: fleetOwnersRoutes,
    },
    {
      path: 'tyres',
      children: tyresRoutes,
    },
  ];
